import React, {useState} from 'react';
import {logPageLoadEvents} from '@ibibo/analytics';
import FileUploaded from './../../../../../onboarding/src/stories/components/OnboardingNew/GccComponents/FileUploaded/FileUploaded';
import FileLoader from './../../../../../onboarding/src/stories/components/OnboardingNew/GccComponents/FileUploader/FileUploader';
import Spinner from './../../../../../onboarding/src/stories/components/OnboardingNew/GccComponents/Spinner/Spinner';
import TextInput from './../../../../../onboarding/src/stories/components/OnboardingNew/GccComponents/TextInput/TextInput';
import TradingLicenseDetails from './../../../../../onboarding/src/stories/components/OnboardingNew/GccComponents/TradingLicenseDetails/TradingLicenseDetails';
import UploadedFiles from './../../../../../onboarding/src/stories/components/OnboardingNew/GccComponents/UploadedFiles/UploadedFiles';
import {Footer} from './../Reports/Footer';
import * as S from './DocUploadModal.styles';
import ButtonLoader from '../../../../../onboarding/src/stories/components/UI/Loader/Loader';
import classNames from 'classnames';
const DocUploadModal = ({
  setFileData,
  approveFileHandler,
  isLoading,
  responseData,
  setTrnNumber,
  licenseNumber,
  setLicenseNumber,
  approve,
  busineesDetails,
  setBusinessDetails,
  disabledInput,
  setDisabledInput,
  setApprove,
  data,
  disableSubmitButton,
  error,
  onCloseIconClick,
  onFormSubmit,
  trnLoader,
  omniComponentName = '',
  allowPastDate = true,
}) => {
  const {header = {}, body = {}, footer = {}} = data || {};
  const winSize = window.screen.width;

  const [filePath, setFilePath] = useState('');
  const [fileType, setFileType] = useState('');
  const [imageSizeExceededError, setImageSizeExceededError] = useState('');
  const [fileName, setFileName] = useState('');

  const getFileInfo = (info) => {
    setFileType(info[0].type);
  };

  const selectFile = (val, fileContent) => {
    setFileName(fileContent?.name);
    setFilePath(val);
    setFileData(fileContent);
    logPageLoadEvents(`onboarding:signup:landing${omniComponentName}`, {
      eVar15: `onboarding:businessdetails|mypartner${omniComponentName}`,
      channel: `onboarding|mypartner${omniComponentName}`,
      prop24: `onboarding|mypartner${omniComponentName}`,
      eVar24: `onboarding|mypartner${omniComponentName}`,
      prop27: `/agent/upload-license${omniComponentName}`,
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: `myPartner_onboarding_upload${omniComponentName}`,
    });
  };

  const onApprove = (uploadAgain = false) => {
    if (!uploadAgain) {
      logPageLoadEvents(`onboarding:signup:landing:kycupdate${omniComponentName}`, {
        eVar15: `onboarding:businessdetails|mypartner${omniComponentName}`,
        channel: `onboarding|mypartner${omniComponentName}`,
        prop24: `onboarding|mypartner${omniComponentName}`,
        eVar24: `onboarding|mypartner${omniComponentName}`,
        prop27: `/agent/upload-license${omniComponentName}`,
        eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
        prop54: `myPartner_onboarding_uploadApprove${omniComponentName}`,
      });
    }
    approveFileHandler();
  };

  const onClose = () => {
    setApprove(false);
    setDisabledInput(false);
    logPageLoadEvents(`onboarding:signup:landing:kycupdate${omniComponentName}`, {
      eVar15: `onboarding:businessdetails|mypartner${omniComponentName}`,
      channel: `onboarding|mypartner${omniComponentName}`,
      prop24: `onboarding|mypartner${omniComponentName}`,
      eVar24: `onboarding|mypartner${omniComponentName}`,
      prop27: `/agent/upload-license${omniComponentName}`,
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: `myPartner_onboarding_uploadRemove${omniComponentName}`,
    });
  };

  const renderSubComponents = (data) => {
    return data?.order?.map((componentName, index) => {
      const componentData = data[componentName];
      if (!componentData) {
        return null;
      }
      switch (componentData?.component) {
        case 'IMAGE_UPLOADER':
          return (
            <>
              <S.TopContent>
                <S.TopContentLft>
                  <S.TopContentTitle> {componentData?.data?.primaryText}</S.TopContentTitle>
                  <S.TopContentSubTitle>
                    <div
                      dangerouslySetInnerHTML={{__html: componentData?.data?.secondaryText}}
                    ></div>
                  </S.TopContentSubTitle>
                </S.TopContentLft>
                <S.TopContentRht>
                  {!isLoading && approve ? (
                    <FileUploaded
                      closeIcon={true}
                      title={fileName}
                      fileSize={''}
                      onClose={onClose}
                    />
                  ) : (
                    <React.Fragment>
                      <FileLoader
                        fileTypes={
                          componentData?.data?.uploadData?.supportedFileTypes || [
                            '.png, .jpeg, .pdf',
                          ]
                        }
                        onFileSelect={selectFile}
                        getFileInfo={getFileInfo}
                        setImageSizeExceededError={setImageSizeExceededError}
                      >
                        <p
                          className="font10"
                          dangerouslySetInnerHTML={{
                            __html: componentData?.data?.uploadData?.primaryText,
                          }}
                        ></p>
                        <p className="font10">{componentData?.data?.uploadData?.secondaryText}</p>
                      </FileLoader>
                      {filePath && (
                        <p className="font11 greyText appendTop5">
                          By proceeding, you agree to MakeMyTrip's T&Cs and Privacy Policy
                        </p>
                      )}
                    </React.Fragment>
                  )}
                  {imageSizeExceededError && <S.ErrorMsg>{imageSizeExceededError}</S.ErrorMsg>}
                </S.TopContentRht>
              </S.TopContent>

              {filePath && !isLoading && !approve && (
                <UploadedFiles
                  fileType={fileType}
                  filePath={filePath}
                  fileTypes={['.png, .jpeg, .pdf']}
                  onFileSelect={selectFile}
                  getFileInfo={getFileInfo}
                  onApprove={onApprove}
                />
              )}
              {isLoading && (
                <S.SpinnerCont>
                  <Spinner
                    width={winSize >= 768 ? '60px' : '32px'}
                    height={winSize >= 768 ? '60px' : '32px'}
                    borderWidth={winSize >= 768 ? '8px' : '4px'}
                  />
                </S.SpinnerCont>
              )}
              {!isLoading && approve && (
                <TradingLicenseDetails
                  responseData={responseData}
                  setTrnNumber={setTrnNumber}
                  busineesDetails={busineesDetails}
                  setBusinessDetails={setBusinessDetails}
                  showEmirates={false}
                  allowPastDate={allowPastDate}
                />
              )}
            </>
          );
        case 'TEXT_BOX':
          return (
            <TextInput
              labelText={componentData?.data?.label}
              placeholder={componentData?.data?.placeholder}
              mobileNumber={false}
              name={componentData?.data?.label}
              component={componentData?.data?.label}
              setterFunction={setLicenseNumber}
              setterObj={licenseNumber}
              disabled={disabledInput}
            />
          );
        default:
          return null;
      }
    });
  };

  const renderFooter = (ctas) => {
    return (
      <S.ContentFooter>
        {trnLoader ? (
          <S.BtnLoader butonWidth={'40px'} isDisabled={disableSubmitButton}>
            <ButtonLoader loaderType="button" />
          </S.BtnLoader>
        ) : (
          <Footer
            isFooterDisabled={disableSubmitButton}
            data={ctas}
            onClickCb={() => {
              onFormSubmit();
            }}
          ></Footer>
        )}
        <p className="textCenter greyText font12 mt5">
          By proceeding, you agree to MakeMyTrip's T&Cs and Privacy Policy
        </p>
      </S.ContentFooter>
    );
  };
  return (
    <S.Container>
      <S.HeadingContainer>
        <span className={classNames('mr12', header?.icon?.iconClasses)} />

        <S.Heading>{header?.primaryText}</S.Heading>
        {header?.showCrossIcon && (
          <S.IconClose className={classNames('mr12 sprite icClose')} onClick={onCloseIconClick} />
        )}
      </S.HeadingContainer>
      <S.SubHeading dangerouslySetInnerHTML={{__html: body?.primaryText}}></S.SubHeading>
      {renderSubComponents(body?.data)}
      <S.EmptySpace></S.EmptySpace>
      {error?.msg && <S.ErrorMsg>{error.msg}</S.ErrorMsg>}
      {renderFooter(footer.ctas)}
    </S.Container>
  );
};

export default DocUploadModal;
